// extracted by mini-css-extract-plugin
export default {"wrapper":"Iz-z","viewport":"Jz-z","container":"Kz-z","slide":"Lz-z"};